'use client'

import { RefObject, useCallback, useState } from 'react'

export interface UseSPCarouselParams {
  videoRef: RefObject<HTMLVideoElement | null>
  shouldAutoPlayRef: RefObject<boolean>
  onVideoSelect: (index: number) => void
  setState: (state: 'playing' | 'paused' | 'detail') => void
}

export interface UseSPCarouselReturn {
  showCarousel: boolean
  handleShowCarousel: () => void
  handleCloseCarousel: () => void
  handleCarouselVideoSelect: (index: number) => void
}

export function useSPCarousel({
  videoRef,
  shouldAutoPlayRef,
  onVideoSelect,
  setState,
}: UseSPCarouselParams): UseSPCarouselReturn {
  const [showCarousel, setShowCarousel] = useState(false)

  // Show carousel
  const handleShowCarousel = useCallback(() => {
    const video = videoRef.current
    if (video && !video.paused) {
      video.pause()
    }
    setState('paused')
    setShowCarousel(true)
  }, [videoRef, setState])

  // Close carousel
  const handleCloseCarousel = useCallback(() => {
    setShowCarousel(false)
  }, [])

  // Handle video select from carousel (A5: with history)
  const handleCarouselVideoSelect = useCallback(
    (index: number) => {
      shouldAutoPlayRef.current = true
      setShowCarousel(false)
      onVideoSelect(index)
    },
    [onVideoSelect, shouldAutoPlayRef],
  )

  return {
    showCarousel,
    handleShowCarousel,
    handleCloseCarousel,
    handleCarouselVideoSelect,
  }
}
